export const discountAmount = (coupon, totalAmount) => {
  if (coupon.discount_percent && coupon.discount_percent > 0) {
    return Math.round((totalAmount * coupon.discount_percent) / 100);
  }
  if (coupon.discount_cents && coupon.discount_cents > 0) {
    return coupon.discount_cents;
  }
  return 0;
};

const computeTotalAmount = ({
  campaignPackage = {},
  impressionBoost = null,
  coupons = [],
  verifiedCoupon = {},
  siteCreditAmount = 0,
  useSiteCredit = false,
  hideCouponLine = false,
  includeVerifiedCoupon = true
}) => {
  const orderLine = campaignPackage.order_line_amount || 0;
  const discountLine = campaignPackage.discount_line_amount;
  const totalAfterDiscount =
    discountLine && discountLine > 0 ? orderLine - discountLine : orderLine;

  const boostCost = impressionBoost && impressionBoost.cost > 0 ? impressionBoost.cost : 0;
  const totalBeforeCoupons = totalAfterDiscount + boostCost;

  let total = totalBeforeCoupons;
  if (!hideCouponLine) {
    coupons.forEach(coupon => {
      total -= discountAmount(coupon, totalBeforeCoupons);
    });
    if (verifiedCoupon?.code && includeVerifiedCoupon) {
      total -= discountAmount(verifiedCoupon, totalBeforeCoupons);
    }
  }
  const totalBeforeCredit = total;

  const hasSiteCredit = siteCreditAmount && siteCreditAmount > 0;
  const siteCreditReadyToUse = hasSiteCredit ? Math.min(totalBeforeCredit, siteCreditAmount) : 0;
  const appliedSiteCredit = useSiteCredit ? siteCreditReadyToUse : 0;

  return Math.max(totalBeforeCredit - appliedSiteCredit, 0);
};

export default computeTotalAmount;
